<template>
  <div id="cardSlider">
    <div class="navigation-container">
      <div class="mosaic-grid-container" id="gridContainer">
        <div class="mosaic-grid">
          <div
            v-for="(item, index) in filteredItems"
            :key="index"
            class="mosaic-item"
            :class="getMosaicClass(index)"
            @click="handleClick(item.link)"
          >
            <div class="zoom-img-container">
              <img 
                :src="item.image" 
                v-set-alt 
                class="zoom-img" 
                :style="{ height: '280px' }"
              />
            </div>
            <div class="item-content text-center" v-html="item.text_content"></div>
          </div>
        </div>
      </div>
      <div class="circle-icon next-slide-button" @click="scroll_right()">
        <img src="../../images/arrow-right-black.svg" alt="Next" />
      </div>
      <div class="circle-icon previous-slide-button" @click="scroll_left()">
        <img src="../../images/arrow-left-black.svg" alt="Previous" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardSlider",
  props: {
    items: {
      type: Array,
      required: true,
    },
    slidesToShow: {
      type: Number,
      default: 6,
    },
    openInNewTab: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    filteredItems() {
      return this.items.filter(i => i.image && i.link);
    }
  },
  methods: {
    handleClick(link) {
      if (this.openInNewTab) {
        window.open(link, "_blank");
      } else {
        this.$router.push(link);
      }
    },
    getMosaicClass(index) {
      // Pattern for 2-row mosaic with specified widths
      const pattern = [
        'wide row1',  // 502px in row 1
        'narrow row1', // 343px in row 1
        'narrow row1', // 343px in row 1
        'wide row2',   // 502px in row 2
        'narrow row2', // 343px in row 2
        'wide row2'    // 502px in row 2
      ];
      return pattern[index % pattern.length];
    },
    scroll_left() {
      let content = document.querySelector("#gridContainer");
      content.scrollLeft -= 220;
    },
    scroll_right() {
      let content = document.querySelector("#gridContainer");
      content.scrollLeft += 220;
    }
  },
};
</script>

<style lang="scss" scoped>
#cardSlider {
  .navigation-container {
    display: flex;
    align-items: center;
    gap: 20px;
    position: relative;
  }

  .mosaic-grid-container {
    flex: 1;
    overflow: auto;
  }

  .mosaic-grid {
    display: grid;
    grid-template-rows: 280px 280px;
    grid-auto-columns: max-content; /* Let columns size to their content */
    gap: 10px;
  }

  .mosaic-item {
    position: relative;
    cursor: pointer;
    overflow: hidden;
    height: 280px;
    
    &.wide {
      min-width: 502px;
      width: 100%;
      grid-column-end: span 2; 
    }
    
    &.narrow {
      min-width: 343px;
      width: 100%;
      grid-column: span 1;
    }
    
    &.row1 {
      grid-row: 1;
    }
    
    &.row2 {
      grid-row: 2;
    }

    .zoom-img-container {
      width: 100%;
      height: 100%;
      
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.3s ease;
      }
    }

    &:hover img {
      transform: scale(1.05);
    }

    .item-content {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 10px;
      color: white;
      background: linear-gradient(transparent, rgba(0,0,0,0.7));
    }
  }

  @media screen and (max-width: 767px) {
    .mosaic-grid {
      grid-template-rows: 238px 238px;
    }

    .mosaic-item {
      height: 238px;
      
      &.wide {
        min-width: 372px;
        width: 100%;
        grid-column-end: span 2; 
      }
      
      &.narrow {
        min-width: 320px;
        width: 100%;
        grid-column: span 1;
      }
    }

    .navigation-container {
      gap: 15px;
    }
  }

  .circle-icon {
    width: 35px;
    height: 35px;
    border: 1px solid #F5F5F5;
    background: #F5F5F5 0% 0% no-repeat padding-box;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    img {
      width: 20px;
    }
  }

  .previous-slide-button {
    position: absolute;
    top: 50%;
    left: -5%;
    transform: translateY(-50%);
    color: #000;

    @media screen and (max-width: 767px) {
      left: 0;
    }
  }

  .next-slide-button {
    position: absolute;
    top: 50%;
    right: -5%;
    transform: translateY(-50%);
    color: #000;

    @media screen and (max-width: 767px) {
      right: 0;
    }
  }
}
</style>